<section class="mainTopBanner">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="topBannerWrapper align-items-center">
                    <div class="top-banner-left">
                        <h1>事例紹介</h1>
                        <h2>Success Stories</h2>
                        <p>Discover how Trinka has transformed writing experiences for institutions, publishers, and organizations worldwide. Explore our case studies to see real-life examples.</p>
                    </div>
                    <div class="top-banner-right">
                        <img src="../../../assets/images/eposter.png" alt="eposter">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd section-purple">
    <div class="container">
        <div class="row match-box">
            <div class="col-md-6 dflex">
                <a [routerLink]="['/case-study/nit']" routerLinkActive="active" class="newsSection">
                    <div class="row align-items-center">
                        <!-- <div class="col-md-12">
                            <div class="accomplishSections_img">
                                <img src="../../../../assets/images/news/2024/crimson-best-place.png" class="img-fluid" alt="Interactive Awarded" />
                            </div>
                        </div> -->
                        <div class="col-md-12">
                            <div class="newsBody">
                                <div class="caseImg">
                                    <img src="../../../assets/images/case-study/nit-case-study.jpg" loading="lazy" decoding="async" alt="nit" class="img-fluid" />
                                </div>
                                <div class="section-title">
                                    <h2>日本工業大学様　
                                        学術英語執筆スキル向上のためTrinkaを導入
                                    </h2>
                                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                                    <p>1907年に前身の東京工科学校が創立した日本工業大学は、日本国内では特に長い歴史を持つ工学系の大学で、「実工学の理念にもとづく工学教育と先進的研究により、新たな価値創造と科学技術の発展に寄与する」という理念のもとに教育・研究活動を行っています。工学・建築・技術経営分野の知識の習得を志すおよそ4,000名の学生が在籍しています。</p>
                                    <div class="btn-group mt-4">
                                        <button type="button" class="filled-btn">Learn More</button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>